import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //const userToken = 'secure-user-token';
    //todo: add anitiforgery token hear
    const modifiedReq = req.clone({
      //headers: req.headers.set('Authorization', `Bearer ${userToken}`),
      headers: req.headers.set('X-Requested-With', 'XMLHttpRequest'),
    });

    return next.handle(modifiedReq);
  }
}
